import { jsxs as l, jsx as e, Fragment as g } from "react/jsx-runtime";
import { Icon as n } from "@tameeni/icons";
import { useInheritDocDirection as d, cn as p } from "@tameeni/shared-logic";
import { AppDownloadSection as f } from "../../shared-pages-components/src/components/app-download-section.js";
import { Animated as t } from "@tameeni/ui";
import u from "../../assets/mobile-image-background-en.png.js";
import h from "../../assets/mobile-image-background-ar.png.js";
import x from "../../assets/mobile-image-foreground-en.png.js";
import b from "../../assets/mobile-image-foreground-ar.png.js";
function D({
  locale: r,
  title: s,
  text: m,
  customImageContent: o
}) {
  const { direction: c } = d({ locale: r }), a = r === "en" ? u : h, i = r === "en" ? x : b;
  return /* @__PURE__ */ l("div", { className: "min-h-[400px] relative bg-blue-100 pb-8", children: [
    /* @__PURE__ */ e(t.FloatingAnimation, { transition: { duration: 5 }, children: /* @__PURE__ */ e(
      n,
      {
        name: "DownloadAppBefore",
        className: "w-40 h-auto absolute -left-[3.5rem] -top-4 lg:-top-12 lg:w-60 z-5"
      }
    ) }),
    /* @__PURE__ */ e(t.FloatingAnimation, { transition: { delay: 0.4, duration: 5 }, children: /* @__PURE__ */ e(
      n,
      {
        name: "DownloadAppAfter",
        className: "w-32 lg:w-auto h-auto lg:h-96 absolute right-0 lg:-right-14 top-16 lg:-top-4 z-5"
      }
    ) }),
    /* @__PURE__ */ e("div", { className: "relative box z-10", children: /* @__PURE__ */ l(
      "div",
      {
        className: p(
          "flex flex-col items-start gap-4 lg:gap-8 lg:flex-row justify-center",
          c === "rtl" ? "lg:flex-row-reverse" : ""
        ),
        children: [
          /* @__PURE__ */ e("div", { className: "relative w-full lg:w-1/3 h-64 z-10", children: /* @__PURE__ */ l("div", { className: "w-48 lg:w-64 lg:h-[30rem] absolute -top-[5.7rem] lg:-top-16 left-1/2 transform -translate-x-1/2", children: [
            !!o && o,
            !o && /* @__PURE__ */ l(g, { children: [
              /* @__PURE__ */ e(
                "img",
                {
                  loading: "lazy",
                  src: typeof a == "string" ? a : a.src,
                  alt: "Mobile App Screenshot",
                  className: "w-full h-auto lg:w-64"
                }
              ),
              /* @__PURE__ */ e(
                "img",
                {
                  loading: "lazy",
                  src: typeof i == "string" ? i : i.src,
                  alt: "Mobile App Screenshot",
                  className: "animate-float max-w-[100px] lg:max-w-[165px] w-full absolute -left-10 lg:-left-20 top-24 bottom-0 my-auto"
                }
              )
            ] })
          ] }) }),
          /* @__PURE__ */ l("div", { className: "pb-0 lg:pt-10 w-full lg:max-w-[600px]", children: [
            /* @__PURE__ */ e(t.Scale, { useScroll: !0, children: /* @__PURE__ */ e("h2", { className: "text-h1 font-semibold lg:text-d2 text-slate-900 mb-4", children: s }) }),
            /* @__PURE__ */ e(t.Scale, { useScroll: !0, transition: { delay: 0.2 }, children: /* @__PURE__ */ e("p", { className: "text-slate-600 text-b2 lg:text-b1 mb-4", children: m }) }),
            /* @__PURE__ */ e(t.Scale, { useScroll: !0, transition: { delay: 0.4 }, children: /* @__PURE__ */ e(
              f,
              {
                englishTitle: "Download our APP now.",
                arabicTitle: "حمل تطبيقنا الآن",
                className: "flex flex-col lg:flex-col items-start lg:items-start",
                hasActiveBorder: !0,
                locale: r
              }
            ) })
          ] })
        ]
      }
    ) })
  ] });
}
export {
  D as default
};
//# sourceMappingURL=index.js.map
